import api from "../services/api";

// Use centralized API service with interceptors
const agentAPI = api;

/**
 * Get all agents
 */
export const getAllAgents = async () => {
  return agentAPI.get("/api/agents");
};

/**
 * Get agent by ID
 */
export const getAgentById = async (id) => {
  return agentAPI.get(`/api/agents/${id}`);
};

/**
 * Create new agent
 */
export const createAgent = async (agentData) => {
  return agentAPI.post("/api/agents", agentData);
};

/**
 * Update agent
 */
export const updateAgent = async (id, agentData) => {
  return agentAPI.put(`/api/agents/${id}`, agentData);
};

/**
 * Update agent password
 */
export const updateAgentPassword = async (id, newPassword) => {
  return agentAPI.put(`/api/agents/${id}/password`, { newPassword });
};

/**
 * Delete agent
 */
export const deleteAgent = async (id) => {
  return agentAPI.delete(`/api/agents/${id}`);
};

export default agentAPI;
